module.exports = __webpack_public_path__ + "img/show.a0530c5a.svg";